<script setup lang="ts">
import { WEB_APP_URL } from '~/constants/website'

useDefaultMeta({
  title: 'Aplikasi Kirim Paket COD Terbaik #1 Indonesia | KiriminAja',
  description:
    'Kirim paket ke seluruh Indonesia dengan pengiriman reguler KiriminAja! Ekspedisi terlengkap, bisa COD, &amp; tanpa minimum jumlah kiriman. Kirim sekarang!'
})

const faqs = [
  {
    question: 'Apa itu pengiriman reguler?',
    answer:
      '<p>Pengiriman Reguler adalah layanan kirim barang satuan dengan ukuran kecil hingga sedang, sangat efisien dan ekonomis. Cocok untuk individu maupun bisnis, jasa pengiriman reguler ini tidak memerlukan administrasi logistik rumit, sehingga cocok untuk kebutuhan harian.</p>'
  },
  {
    question: 'Apa yang dimaksud dengan kirim paket reguler?',
    answer:
      '<p>Kirim Paket Reguler mengacu pada pengiriman barang-barang yang dikirim melalui layanan reguler, biasanya dengan ukuran kecil hingga sedang. Contohnya adalah dokumen, pakaian, atau barang kebutuhan sehari-hari lainnya.</p>'
  },
  {
    question: 'Apakah pengiriman reguler cepat? Berapa lama waktunya?',
    answer:
      '<p>Ya, pengiriman reguler umumnya cepat. Biasanya memerlukan waktu 3-5 hari kerja, tergantung lokasi pengirim dan penerima.</p>'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Pengiriman Lengkap dengan Pembayaran COD & Non-COD"
      sub-title="Pengiriman Reguler ke Seluruh Indonesia"
      description="Banyak pilihan ekspedisi yang dapat dipesan untuk kirim paket sesuai kebutuhanmu."
      hero-image="/images/batch-2/regular-welcome.avif"
      button-label="Kirim Paket Sekarang"
      :button-link="$utm.utmUrl(WEB_APP_URL)"
    />
    <LayananRegulerBenefit />
    <LayananRegulerKirimPaketCOD />
    <LayananRegulerCaraKirimPaket />
    <LayananRegulerExpedition />
    <LayananPilihanLayanan />
    <FaqBase :faqs="faqs" />
    <CtaSection />
  </div>
</template>
